import { render, staticRenderFns } from "./Combo.vue?vue&type=template&id=4e607334&scoped=true"
import script from "./Combo.vue?vue&type=script&lang=js"
export * from "./Combo.vue?vue&type=script&lang=js"
import style0 from "./Combo.vue?vue&type=style&index=0&id=4e607334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e607334",
  null
  
)

export default component.exports